"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAddToCartEvent = void 0;

var _constants = _interopRequireDefault(require("../constants"));

var _Utils = _interopRequireDefault(require("../Utils"));

var createAddToCartEvent = function createAddToCartEvent(item) {
  var addToCartEvent = {};

  _Utils["default"].setEventCategory(addToCartEvent, _constants["default"].PrimaryCategories.Overlay);

  _Utils["default"].setEventEventInfo(addToCartEvent, _constants["default"].EventNames.CartAdd);

  _Utils["default"].setEventProperty(addToCartEvent, _constants["default"].PropertyPaths.Item, item);

  return addToCartEvent;
};

exports.createAddToCartEvent = createAddToCartEvent;
//# sourceMappingURL=addToCart.js.map